import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { FeedbackPage } from "@/presentation/components/requests/feedback-page";

const searchSchema = z.object({ id: z.string().optional() });

// The same feedback list as /feedback, in the B2C Implementation workspace (BF-1440).
export const Route = createFileRoute("/_app/b2c/feedback/")({
  validateSearch: searchSchema,
  component: B2cFeedbackPage,
});

function B2cFeedbackPage() {
  const navigate = useNavigate({ from: Route.fullPath });
  const { id } = Route.useSearch();
  return (
    <FeedbackPage
      eyebrow="B2C Implementation"
      openId={id ?? null}
      onOpen={(next) => navigate({ search: { id: next } })}
      onClose={() => navigate({ search: {} })}
    />
  );
}
